let crcTable;

const makeCRCTable = (): Array<number> => {
    let c;
    const crcTable = [];
    for (let n = 0; n < 256; n++) {
        c = n;
        for (let k = 0; k < 8; k++) {
            // eslint-disable-next-line no-bitwise
            c = c & 1 ? 0xedb88320 ^ (c >>> 1) : c >>> 1;
        }
        crcTable[n] = c;
    }
    return crcTable;
};

export const crc32 = (str: string): number => {
    const table = crcTable || (crcTable = makeCRCTable());
    // eslint-disable-next-line no-bitwise
    let crc = 0 ^ -1;

    for (let i = 0; i < str.length; i++) {
        // eslint-disable-next-line no-bitwise
        crc = (crc >>> 8) ^ table[(crc ^ str.charCodeAt(i)) & 0xff];
    }

    // eslint-disable-next-line no-bitwise
    return (crc ^ -1) >>> 0;
};
